import { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

interface Props {
    children?: ReactNode;
    isBold?: boolean;
    size?: 'medium' | 'small' | 'tiny';
    className?: string;
    isGray?: boolean;
    dangerouslySetInnerHTML?: { __html: string };
    ariaHidden?: boolean | 'true' | 'false';
}

export function Paragraph({
    children,
    isBold = false,
    size,
    className,
    isGray = false,
    dangerouslySetInnerHTML,
    ariaHidden,
}: Props) {
    return (
        <p
            className={twMerge(
                isBold ? 'font-medium' : 'font-normal',
                isGray ? 'text-neutral-500' : 'text-neutral-700',
                size === 'small' && 'text-sm',
                size === 'tiny' && 'text-xs',
                size === 'medium' && 'text-md',
                className,
            )}
            aria-hidden={ariaHidden}
            dangerouslySetInnerHTML={dangerouslySetInnerHTML}>
            {children}
        </p>
    );
}
